import Orientamento2 from 'images2/inclusione/Orientamento 2.png';
import Orientamento3 from 'images2/inclusione/Orientamento 3.png';
import Orientamento1 from 'images2/inclusione/Orientamento 1.png';

export const orariSettimanali = [
  {
    dayName: 'Lunedì',
    value: {
      from: '9',
      to: '17',
    },
  },
  {
    dayName: 'Martedì',
    value: {
      from: '9',
      to: '17',
    },
  },
  {
    dayName: 'Mercoledì',
    value: {
      from: '9',
      to: '13',
    },
  },
  {
    dayName: 'Giovedì',
    value: {
      from: '9',
      to: '17',
    },
  },
  {
    dayName: 'Venerdì',
    value: {
      from: '9',
      to: '17',
    },
  },
  // {
  //   dayName: 'Sabato',
  //   value: {
  //     from: '9',
  //     to: '17',
  //   },
  // },
];

export const stepList = [
  {
    title: 'PRE-PARTENZA',
    img: Orientamento1,
    tag: 'prepartenza',
  },
  {
    title: 'IN ITALIA',
    img: Orientamento2,
    tag: 'initalia',
  },
  {
    title: 'EXTRASCUOLA',
    img: Orientamento3,
    tag: 'extrascuola',
  },
];
